module.exports = __webpack_public_path__ + "static/img/4-6.a0e335a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-6.jpg
// module id = xvzX
// module chunks = 25